import { Container } from 'inversify';

import { registerServices } from '@src/services';

export async function setup(): Promise<Container> {
  const container = new Container();
  registerServices(container);

  // Perform any additional setup if needed
  console.log('Services registered in container');

  return container;
}
